var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-up",class:{ 'wrapper-up--enrollment-drawer': _vm.enrollmentDrawerOpen }},[_c('div',{staticClass:"wrapper"},[_c('TheHeader',{attrs:{"show-logo-menu":_vm.showLogoMenu,"showMenu":_vm.showMenu},on:{"isCloseUserAvatar":_vm.isShowOrNotShowUserAvatar,"showMenu":_vm.changeShowMenu}}),_vm._v(" "),_c('TheSidebarOld',{on:{"showMenu":_vm.changeShowMenu}}),_vm._v(" "),_c('main',{staticClass:"main main--tablet",class:[
        {
          main__sidebar_opened:
            _vm.showSidebar && _vm.$route.path.split('/')[1] !== 'security'
        },
        { 'main--moved-xl': _vm.getDayRecordPanel },
        { mobile: _vm.isMobile },
        { 'main--moved': _vm.showMenu },
        {
          'main—move-locked':
            _vm.showMenu && _vm.$route.path.split('/')[1] === 'security'
        }
      ],on:{"click":() => {
          _vm.isCloseUserAvatar();
          _vm.isCloseDropDownList();
        }}},[_vm._t("default")],2),_vm._v(" "),_c('TheFooter')],1),_vm._v(" "),_c('TheBottomMenu'),_vm._v(" "),_c('TheMobileTabBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }